
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { Month } from 'components/OpenHouseBanner/OpenHouseBanner.utilities';
import dayjs from 'dayjs';
import { useAtom } from 'jotai';
import { current_language } from 'state/store.global';

const CustomCalendarHeaderRoot = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '16px 24px 0px 24px',
  height: '24px',
  alignItems: 'center',
  color: '#000'
});

export const CalendarHeader = (props) => {
  const { currentMonth, onMonthChange } = props;
  const language = useAtom(current_language)[0];


  const selectNextMonth = () => onMonthChange(currentMonth.add(1, 'month'), 'left');
  const selectNextYear = () => onMonthChange(currentMonth.add(1, 'year'), 'left');
  const selectPreviousMonth = () =>
    onMonthChange(currentMonth.subtract(1, 'month'), 'right');
  const selectPreviousYear = () =>
    onMonthChange(currentMonth.subtract(1, 'year'), 'right');
 
  return (
    <CustomCalendarHeaderRoot>
      <Stack spacing={1} direction="row">
      {/* <MonthCalendar /> */}
      {/* <YearCalendar /> */}
        {/* <IconButton onClick={selectPreviousYear} title="Previous year">
          <KeyboardDoubleArrowLeftIcon />
        </IconButton> */}
        <IconButton sx={{ padding: 0 }} onClick={selectPreviousMonth} title="Previous month">
          <ChevronLeft />
        </IconButton>
      </Stack>
      <Typography className='h5-medium' sx={{ textTransform: 'capitalize' }}>
        {/* {currentMonth.locale(language).format('MMMM YYYY')} */}
               {Month(currentMonth, language)} {dayjs(currentMonth).format('YYYY')}
        </Typography>
      <Stack spacing={1} direction="row">
        <IconButton sx={{ padding: 0 }} onClick={selectNextMonth} title="Next month">
          <ChevronRight />
        </IconButton>
        {/* <IconButton onClick={selectNextYear} title="Next year">
          <KeyboardDoubleArrowRightIcon />
        </IconButton> */}
      </Stack>
    </CustomCalendarHeaderRoot>
  );
}
